import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { OverlaiedLoader } from '../Loader';
import Card from './card';
import './index.scss';

const COLOR = {
  pendente: 'yellow',
  glosa: 'red',
  analise: 'blue',
  RECURSADO: 'red'
};

const STATUS = {
  pendente: 'Pendente imagem',
  GLOSADO: 'Glosa',
  analise: 'Em análise',
  RECURSADO: 'Recursado'
};

class ProcedureGto extends Component {
  state = { loader: false };

  loader = ({ isLoading }) => this.setState({ loader: isLoading });

  render() {
    const {
      face,
      index,
      status,
      regiao,
      codBenef,
      readOnly,
      codProced,
      glosaCount,
      procedimento,
      updateStatusProcedimento,
      reason,
      planId,
      gtoId,
      procedureId
    } = this.props;

    return (
      <Fragment>
        {this.state.loader && <OverlaiedLoader />}

        <li className={`item color-${COLOR[status]}`}>
          <label className="title active">{STATUS[status]}</label>
          <h5 className="nameProcedure">{`${procedimento} - ${codProced}`}</h5>
          <p className="region">
            {regiao && <span>{`Dente/ Região: ${regiao}`}</span>}
            {face && <span>{`Face: ${face}`}</span>}
          </p>
          <Card
            face={face}
            index={index}
            status={status}
            regiao={regiao}
            codBenef={codBenef}
            readOnly={readOnly}
            codProced={codProced}
            descrGlosa={reason}
            glosaCount={glosaCount}
            planId={planId}
            gtoId={gtoId}
            procedureId={procedureId}
            updateStatusProcedimento={updateStatusProcedimento}
            loader={this.loader}
          />
        </li>
      </Fragment>
    );
  }
}

ProcedureGto.propTypes = {
  face: PropTypes.string,
  index: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  glosaCount: PropTypes.number.isRequired,
  descrGlosa: PropTypes.string,
  updateStatusProcedimento: PropTypes.func.isRequired
};

export default ProcedureGto;
